import React from 'react';

import RelatorioSecoesView from 'components/Relatorios/shared/Aprovacao/RelatorioSecoesView';

/**
 * Aba "Informe DECOMP": delega às sub-abas/aprovação genéricas
 * (`RelatorioSecoesView`), configuradas em `helper/Relatorios/Aprovacao/config`.
 */
export default function DecompView() {
  return <RelatorioSecoesView informe="decomp" />;
}
